import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { MzBaseModal } from 'ngx-materialize';

/*
 * Detalle de Bitacora de movimiento 
 *
 *By jsoler
 */
@Component({
  selector: 'app-modal-diff',
  templateUrl: './modal-diff.component.html',
  styleUrls: ['./modal-diff.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ModalDiffComponent  extends MzBaseModal implements OnInit{
  
  @Input() public regBitacora: any;
  
  // LLaves totales  
  public jsonKeysValExtr: any[];
  // objectos formateados para presentar
  public formatValLast: Object;
  public formatValNews: Object;

  public modalOptions: Materialize.ModalOptions = {
    dismissible: false, // Modal can be dismissed by clicking outside of the modal
    opacity: .5, // Opacity of modal background
    inDuration: 300, // Transition in duration
    outDuration: 300, // Transition out duration
  };

  constructor( ) { super(); }

  ngOnInit() {        
    this.jsonKeysValExtr = [];    
    let replace = /\&#34;/gi;

    // recorrido de valores Anteriores
    if( this.regBitacora['valoresAnteriores'] ) {
      let valAnteriores = this.regBitacora['valoresAnteriores'].replace(replace,"\"");
      let jsonRefValAnt = JSON.parse(valAnteriores);
      // obtenemos llaves de campos base       
      this.formatValLast = this.scanKeysExtra( jsonRefValAnt );
    }
    
    // recorrido de valores Nuevos
    if( this.regBitacora['valoresNuevos'] ) {
      let valNuevos = this.regBitacora['valoresNuevos'].replace(replace,"\"");
      let jsonRefValNue =  JSON.parse(valNuevos);
      // obtenemos llaves de campos base       
      this.formatValNews = this.scanKeysExtra( jsonRefValNue );
     }
  }


  /*
   * Scaneo de items Extra 
   */
  private scanKeysExtra( objectItem : any[]): Object {
    
    let objectFormat: Object = {};
    
    objectItem.forEach( (key) => {      
      if( !this.jsonKeysValExtr.includes(key.bubCatCamposConfigIdCampoPk + '--' + key.descripcionCampo) ) {
        this.jsonKeysValExtr.push(key.bubCatCamposConfigIdCampoPk + '--' + key.descripcionCampo);
      }        
      objectFormat[key.bubCatCamposConfigIdCampoPk + '--' + key.descripcionCampo] = key.valor ;
    });

    return objectFormat;
  }

  /* comparacion de valores */
  classValues(value) {
   // console.log("--->", value);
    let classes = "";
    if ((this.formatValLast[value] === undefined 
      || this.formatValLast[value] === null 
      || this.formatValLast[value] === '') &&
      (this.formatValNews[value] === undefined 
        || this.formatValNews[value] === null 
        || this.formatValNews[value] === '')) {
          classes = "";
    } else if(  this.formatValNews[value] === undefined 
      || this.formatValNews[value] === null 
      || this.formatValNews[value] === '' ){
        classes = "color-delete"
    } else if( this.formatValLast[value] !== this.formatValNews[value]  ) {
      classes = "color-change"
    }

    return classes;
  }

  validateValue(valueItem){
    let valueFinal = valueItem;
    if( valueItem === true || valueItem === 'true'){
      valueFinal = 'ACTIVO'
    } else if( valueItem === 'false'|| valueItem === false){
      valueFinal = 'INACTIVO'
    }
    return valueFinal;
  }

}
